export default function() {
  const seasonNumber = this.episode && this.episode.airedSeason || this.seasonNumber;
  this.episode = this.$store.getters.randomEpisode(this.within, seasonNumber);
  this.$router.push({
    name: 'random-season-episode',
    params: {
      seasonNumber: this.episode.airedSeason,
      episodeNumber: this.episode.airedEpisodeNumber
    },
    query: {
      within: this.within
    }
  });
}



// WEBPACK FOOTER //
// ./src/lib/getRandomEpisode.js